import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// RBAC (2026-02-27+): the backend now emits `super_admin | verifier |
// support` for admin users. Legacy `admin` accounts (pre-RBAC) are
// server-normalized to super_admin but the raw value may still leak
// through /auth/me — treat it as admin here too. Broker/other roles
// never match.
const ADMIN_ROLES = new Set(["super_admin", "verifier", "support", "admin"]);

export function isAdminRole(role) {
  return ADMIN_ROLES.has(role);
}
